import FuseUtils from '@fuse/utils';
import pagesConfigs from 'app/main/pages/pagesConfigs';
import React from 'react';
import { Navigate } from 'react-router-dom';

const routeConfigs = [
  ...pagesConfigs
];

const routes = [
  // if you want to make whole app auth protected by default change defaultAuth for example:
  // ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin','staff','user']),
  // The individual route configs which has auth option won't be overridden.
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, [
    'ROLE_USER',
    'ROLE_ADMIN',
    'ROLE_SUPER_ADMIN'
  ]),
  {
    path: "*",
    component: () => <Navigate to="/error-404" />
  }
];

export default routes;
